var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "no-close-on-backdrop": true,
        "no-close-on-esc": true,
        "hide-header-close": true,
        "ok-disabled": _vm.isSaving
      },
      on: { ok: _vm.saveData, cancel: _vm.sendResultBack },
      model: {
        value: _vm.display,
        callback: function($$v) {
          _vm.display = $$v
        },
        expression: "display"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("message.my_listings.add_pet_types")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._l(_vm.globalState.petTypes, function(petType) {
            return _c(
              "div",
              {
                staticClass:
                  "d-flex bg-light border rounded p-2 justify-content-center align-items-center mb-3",
                class: [
                  _vm.selectedPetTypes.includes(petType)
                    ? "border-info"
                    : "border-light"
                ]
              },
              [
                _c("div", { staticClass: "flex-fill" }, [
                  _c("h4", { staticClass: "p-0 m-0" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label p-0 m-0 d-block",
                        attrs: { for: "petType" + petType.id }
                      },
                      [
                        _c("img", {
                          attrs: { src: petType.image_url, with: "48" }
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("multiLangName")(petType)) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedPetTypes,
                        expression: "selectedPetTypes"
                      }
                    ],
                    attrs: { type: "checkbox", id: "petType" + petType.id },
                    domProps: {
                      value: petType,
                      checked: Array.isArray(_vm.selectedPetTypes)
                        ? _vm._i(_vm.selectedPetTypes, petType) > -1
                        : _vm.selectedPetTypes
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.selectedPetTypes,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = petType,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.selectedPetTypes = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedPetTypes = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedPetTypes = $$c
                        }
                      }
                    }
                  })
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.remark,
                expression: "remark"
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasOtherPetType(),
                expression: "hasOtherPetType()"
              }
            ],
            staticClass: "form-control input-jumbo",
            class: { "form-alert": _vm.hasOtherPetType() && _vm.errorNoRemark },
            attrs: {
              type: "text",
              placeholder: _vm.$t("message.my_listings.pet_remark_placeholder")
            },
            domProps: { value: _vm.remark },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.remark = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.hasOtherPetType() && _vm.errorNoRemark
            ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n    "
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-cancel" }, slot: "modal-cancel" }, [
        _vm._v(_vm._s(_vm.$t("message.button.close")))
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-ok" }, slot: "modal-ok" }, [
        _vm._v(
          _vm._s(
            _vm.isSaving
              ? _vm.$t("message.button.loading")
              : _vm.$t("message.button.save")
          )
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-951be2d2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-951be2d2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/PetTypeModal.vue
// module id = 1836
// module chunks = 0